export const COOKIE_CONSENT_KEY = 'AonCookieConsent'
